<template>
    <contacts-module-component/>
</template>

<script>
    import ContactsModuleComponent from "@/components/admin/ContactsModuleComponent";
    
    export default {
        name: "ContactsModules",
        title: "Gestión de Contactos | Equity Baja",
        components: {ContactsModuleComponent}
    }
</script>

<style scoped>

</style>